/**
 * Màn hình quản lý trại
 */
import { memo } from "react";
import { Layout, Space, Typography } from "antd";
import ListPigFarm from "./ListPigFarm";
const { Title } = Typography;
const { Content } = Layout;
function PigFarm() {
  return (
    <Content
      className="custom-layout-content background-content-layout"
      style={{
        marginLeft: 24,
        marginTop: 16,
        marginRight: 24,
        // backgroundColor: "white",
      }}
    >
      <Space
        direction="vertical"
        style={{
          width: "100%",
        }}
        size={"large"}
      >
        <div className="space-between ">
          <Title style={{ marginBottom: 0 }} level={4}>
            Danh sách trại
          </Title>
        </div>
        <ListPigFarm />
      </Space>
    </Content>
  );
}

export default memo(PigFarm);
